import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ExternalLink } from "lucide-react";

const NeobuxEstrategiaPage = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <main className="container mx-auto px-4 py-8">
        <h1 className="text-4xl font-bold text-center mb-8">Estratégia Neobux</h1>
        
        <div className="text-center mb-8">
          <Button 
            size="lg"
            className="bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800"
            onClick={() => window.location.href = "/neobux-cadastro"}
          >
            Criar Conta no Neobux Agora
          </Button>
        </div>
        
        <div className="grid gap-8 md:grid-cols-2">
          <Card className="shadow-lg">
            <CardHeader>
              <CardTitle className="text-2xl">Playlist de Estratégias Neobux</CardTitle>
              <CardDescription>
                Coleção de dicas e estratégias para maximizar seus ganhos no Neobux
              </CardDescription>
            </CardHeader>
            <CardContent>
              <p className="mb-4">
                Acesse nossa coleção completa de estratégias para Neobux no Pinterest. 
                Aprenda como otimizar seus cliques e aumentar seus ganhos diários.
              </p>
              <Button className="w-full" onClick={() => window.open("https://br.pinterest.com/crisgride/eatrategia-neobux/", "_blank")}>
                Ver Playlist no Pinterest <ExternalLink className="ml-2 h-4 w-4" />
              </Button>
            </CardContent>
          </Card>

          <Card className="shadow-lg">
            <CardHeader>
              <CardTitle className="text-2xl">Acertando a Pesquisa no Neobux</CardTitle>
              <CardDescription>
                Como acertar pesquisas de $0,21 e $0,01 no Neobux
              </CardDescription>
            </CardHeader>
            <CardContent>
              <p className="mb-4">
                Descubra técnicas comprovadas para acertar as pesquisas no Neobux e ganhar $0,21 e $0,01 
                por pesquisa. Aumente sua renda diária com estas dicas exclusivas.
              </p>
              <Button className="w-full" onClick={() => window.open("https://lucropagina.blogspot.com/2025/04/acertando-pesquisa-no-neobux.html", "_blank")}>
                Ler o Guia Completo <ExternalLink className="ml-2 h-4 w-4" />
              </Button>
            </CardContent>
          </Card>
        </div>

        <div className="mt-12">
          <Card className="shadow-lg">
            <CardHeader>
              <CardTitle className="text-2xl">Dicas para Iniciantes no Neobux</CardTitle>
            </CardHeader>
            <CardContent>
              <ul className="list-disc pl-5 space-y-2">
                <li>Clique em todos os anúncios disponíveis diariamente</li>
                <li>Invista em referidos alugados quando possível</li>
                <li>Mantenha uma rotina consistente de cliques</li>
                <li>Utilize as estratégias de pesquisa para maximizar ganhos</li>
                <li>Acompanhe seus resultados e ajuste sua estratégia</li>
                <li>Reinvista seus ganhos para crescimento exponencial</li>
              </ul>
            </CardContent>
          </Card>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NeobuxEstrategiaPage;